import type { FavoriteList as KmmFavoriteList } from '@norlys-a-s/norlys-play-kmm';
import { FavoritesList } from '@smart-tv/contexts/favorites-lists-context/favorites-lists-context';

import { kmm } from './kmm';

const responseMapper = (lists: ReadonlyArray<KmmFavoriteList>): FavoritesList[] =>
  lists.map((list, index) => ({
    id: index,
    name: list.name,
    sids: Array.from(list.sids.asJsReadonlyArrayView())
  }));

export const getCustomerFavoritListsWithSidsKmm = async (): Promise<FavoritesList[]> => {
  const lists = await kmm((repo) => repo.getCustomerFavoriteListsWithSids());
  const listArray = Array.from(lists.asJsReadonlyArrayView());

  return responseMapper(listArray);
};

export default getCustomerFavoritListsWithSidsKmm;
